<template>
  <div class="row">

    <!-- 🔹 COLONNE GAUCHE : LISTE -->
    <div class="col-md-4 border-end">

      <h5 class="mb-3">Timeline</h5>

      <input
          type="text"
          class="form-control mb-3"
          placeholder="Rechercher"
          v-model="search"
      />

      <button
          type="button"
          v-if="!viewMode"
          class="btn btn-primary w-100 mb-3"
          @click="createNew"
      >
        <i class="fe fe-plus me-1"></i>
        Ajouter un jalon
      </button>

      <div
          v-for="(item, index) in filteredTimelines"
          :key="index"
          class="card mb-2 cursor-pointer"
          :class="{ 'bg-primary-transparent': selectedIndex === index }"
          @click="select(index)"
      >
        <div class="card-body p-3">
          <strong>{{ item.title || 'Sans titre' }}</strong>
          <div class="text-muted small">
            {{ formatDate(item.eventDate) }}
          </div>
        </div>
      </div>

    </div>

    <!-- 🔹 COLONNE DROITE : DÉTAIL -->
    <div class="col-md-8">

      <h5 class="mb-4">Description du jalon</h5>

      <div v-if="selectedIndex === null" class="text-muted">
        Sélectionnez un jalon à gauche
      </div>

      <div v-else>

        <!-- ACTIONS -->
        <div class="d-flex justify-content-end gap-2 mb-4">
          <button
              type="button"
              v-if="editMode"
              class="btn btn-outline-secondary"
              @click="cancelEdit"
          >
            Ignorer
          </button>

          <button
              type="button"
              v-if="editMode"
              class="btn btn-primary"
              @click="apply"
          >
            Valider
          </button>

          <button
              type="button"
              v-if="!editMode && !viewMode"
              class="btn btn-primary"
              @click="editMode = true"
          >
            Modifier
          </button>

          <button
              type="button"
              v-if="!viewMode"
              class="btn btn-outline-danger"
              @click="remove"
          >
            Supprimer
          </button>
        </div>

        <!-- FORM -->
        <div class="row">

          <!-- TITRE -->
          <div class="col-md-6 mb-3">
            <FieldViewEdit
                label="Titre"
                v-model="form.title"
                :viewMode="viewMode || !editMode"
                :required="true"
            />
          </div>

          <!-- DATE -->
          <div class="col-md-6 mb-3">
            <FieldViewEdit
                label="Date"
                type="date"
                v-model="form.eventDate"
                :viewMode="viewMode || !editMode"
                :required="true"
            />
          </div>

          <!-- DESCRIPTION -->
          <div class="col-md-12 mb-3">
            <FieldViewEdit
                label="Description"
                type="textarea"
                v-model="form.description"
                :viewMode="viewMode || !editMode"
            />
          </div>

        </div>



      </div>

    </div>

  </div>
</template>
<script>
  import FieldViewEdit from "@/components/forms/FieldViewEdit.vue";

  export default {
    name: "ProjectTimeline",
    components: { FieldViewEdit },
    props: {
      value: {
        type: Array,
        required: true,
      },
      viewMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectedIndex: null,
        form: {},
        editMode: false,
        search: "",
      };
    },
    computed: {
      filteredTimelines() {
        return this.value.filter(t =>
            (t.title || "").toLowerCase().includes(this.search.toLowerCase())
        );
      },
    },
    methods: {
      select(index) {
        this.selectedIndex = index;
        this.form = { ...this.value[index] };
        this.editMode = false;
      },
      createNew() {
        this.selectedIndex = this.value.length;
        this.form = {
          title: "",
          description: "",
          eventDate: null,
        };
        this.editMode = true;
      },
      apply() {
        const updated = [...this.value];
        updated[this.selectedIndex] = { ...this.form };
        this.$emit("input", updated);
        this.editMode = false;
      },
      remove() {
        const updated = [...this.value];
        updated.splice(this.selectedIndex, 1);
        this.$emit("input", updated);
        this.selectedIndex = null;
      },
      cancelEdit() {
        this.form = { ...this.value[this.selectedIndex] };
        this.editMode = false;
      },
      formatDate(date) {
        if (!date) return "-";
        return new Date(date).toLocaleDateString();
      },
    },
  };
</script>
